import { makeStyles } from '@material-ui/core/styles';

const PortalNavigationStyles = makeStyles(
  ({ palette, spacing, breakpoints }) => ({
    root: {
      display: 'block',
      position: 'relative',
      width: '100%',

      [breakpoints.up('md')]: {
        display: 'inline-block',
        padding: 0,
        width: (props: any) => (props.isSticky ? '100%' : 'auto'),
      },

      [breakpoints.down('sm')]: {
        margin: spacing(0, -4),
        width: `calc(100% + ${spacing(8)}px)`,
      },

      '& button': {
        paddingBlock: '0 !important',
        appearance: 'none',
      },
    },
  }),
  { name: 'PortalNavigation' },
);

export default PortalNavigationStyles;
